'use client';

import { FC, SVGProps } from 'react';
import colors from '@/constants/theme/colors';

const HeartSvgIcon: FC<SVGProps<SVGSVGElement>> = ({
  fill = colors.primary[25],
  width = '1.5rem',
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M11.6674 4.90103L12.0009 5.19972L12.3345 4.90111C13.3818 3.96358 14.7485 3.46279 16.1536 3.50166C17.5587 3.54053 18.8956 4.1161 19.8894 5.11011L19.8895 5.11015C20.8826 6.10308 21.4582 7.43825 21.4984 8.84198C21.5385 10.2411 21.0437 11.6027 20.115 12.6495L11.9991 20.7769L3.88499 12.6494C2.95519 11.6021 2.45984 10.2393 2.50035 8.83902C2.54099 7.43416 3.1179 6.09815 4.11264 5.10529C5.10738 4.11243 6.44447 3.53804 7.8494 3.50006C9.25433 3.46207 10.6205 3.96337 11.6674 4.90103Z"
        fill={fill}
        stroke="#E2E2E2"
      />
    </svg>
  );
};

export default HeartSvgIcon;
